import script from "./404.vue?vue&type=script&setup=true&lang=js"
export * from "./404.vue?vue&type=script&setup=true&lang=js"

import "./404.vue?vue&type=style&index=0&id=5848f5d2&lang=scss&scoped=true"

import exportComponent from "D:\\六问前端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5848f5d2"]])

export default __exports__